import Skeleton, { type SkeletonProps } from "@mui/material/Skeleton";
import styled from "styled-components";

interface Props extends SkeletonProps {
  isLoading: boolean;
}

const StyledSkeleton = styled(Skeleton)`
  background-color: ${(props) => props.theme.palette.secondary.main}33;
  border-radius: ${(props) => props.theme.borderRadius};
`;

export const BlPrimarySkeletonWrapper = ({ isLoading, ...rest }: Props) => {
  if (isLoading) {
    return <StyledSkeleton {...rest} />;
  }

  return <>{rest.children}</>;
};
